import React, { createContext, useContext, useState, useCallback } from 'react';

export type ConsentType = 'geolocation' | 'photo';

interface ConsentContextType {
  geoConsent: boolean;
  photoConsent: boolean;
  grantConsent: (type: ConsentType) => void;
  revokeConsent: (type: ConsentType) => void;
}

const ConsentContext = createContext<ConsentContextType | undefined>(undefined);

export const ConsentProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [geoConsent, setGeoConsent] = useState(() => localStorage.getItem('consent_geolocation') === 'true');
  const [photoConsent, setPhotoConsent] = useState(() => localStorage.getItem('consent_photo') === 'true');

  const grantConsent = useCallback((type: ConsentType) => {
    if (type === 'geolocation') {
      setGeoConsent(true);
      localStorage.setItem('consent_geolocation', 'true');
    } else if (type === 'photo') {
      setPhotoConsent(true);
      localStorage.setItem('consent_photo', 'true');
    }
  }, []);

  const revokeConsent = useCallback((type: ConsentType) => {
    if (type === 'geolocation') {
      setGeoConsent(false);
      localStorage.removeItem('consent_geolocation');
    } else if (type === 'photo') {
      setPhotoConsent(false);
      localStorage.removeItem('consent_photo');
    }
  }, []);

  return (
    <ConsentContext.Provider value={{ geoConsent, photoConsent, grantConsent, revokeConsent }}>
      {children}
    </ConsentContext.Provider>
  );
};

// eslint-disable-next-line react-refresh/only-export-components
export function useConsent() {
  const ctx = useContext(ConsentContext);
  if (!ctx) throw new Error('useConsent must be used within a ConsentProvider');
  return ctx;
} 